export interface ShopifyCountry {
    iso2: string
    name: string
}

import shopifyData from './countries.shopify.json' assert { type: 'json' }
export const countriesShopifyWithGlobal = shopifyData as ShopifyCountry[];

export const byIso2 = Object.fromEntries(
    countriesShopifyWithGlobal.map(c => [c.iso2, c])
) as Record<string, ShopifyCountry>
